"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _deepExtend = _interopRequireDefault(require("deep-extend"));

var _reactHooks = require("@trycourier/react-hooks");

var _LoadingIndicator = _interopRequireDefault(require("./LoadingIndicator"));

var Styled = _styledComponents["default"].div.withConfig({
  displayName: "LoadingMessages__Styled",
  componentId: "bc5fxt-0"
})(function (_ref) {
  var _theme$brand$inapp$em, _theme$brand, _theme$brand$inapp, _theme$brand$inapp$em2;

  var theme = _ref.theme;
  return (0, _deepExtend["default"])({
    width: "100%",
    height: "100%",
    background: "var(--ci-background)",
    fontSize: 14,
    fontWeight: 600,
    color: (_theme$brand$inapp$em = theme === null || theme === void 0 ? void 0 : (_theme$brand = theme.brand) === null || _theme$brand === void 0 ? void 0 : (_theme$brand$inapp = _theme$brand.inapp) === null || _theme$brand$inapp === void 0 ? void 0 : (_theme$brand$inapp$em2 = _theme$brand$inapp.emptyState) === null || _theme$brand$inapp$em2 === void 0 ? void 0 : _theme$brand$inapp$em2.textColor) !== null && _theme$brand$inapp$em !== void 0 ? _theme$brand$inapp$em : "inherit"
  }, theme === null || theme === void 0 ? void 0 : theme.emptyState);
});

var LoadingMessages = function LoadingMessages(_ref2) {
  var _ref3, _labels$emptyState, _brand$inapp, _brand$inapp$emptySta;

  var labels = _ref2.labels,
      noResults = _ref2.noResults;

  var _useInbox = (0, _reactHooks.useInbox)(),
      brand = _useInbox.brand;

  return /*#__PURE__*/_react["default"].createElement(Styled, null, /*#__PURE__*/_react["default"].createElement(_LoadingIndicator["default"], {
    finished: noResults
  }, (_ref3 = (_labels$emptyState = labels === null || labels === void 0 ? void 0 : labels.emptyState) !== null && _labels$emptyState !== void 0 ? _labels$emptyState : brand === null || brand === void 0 ? void 0 : (_brand$inapp = brand.inapp) === null || _brand$inapp === void 0 ? void 0 : (_brand$inapp$emptySta = _brand$inapp.emptyState) === null || _brand$inapp$emptySta === void 0 ? void 0 : _brand$inapp$emptySta.text) !== null && _ref3 !== void 0 ? _ref3 : "You’re all caught up"));
};

var _default = LoadingMessages;
exports["default"] = _default;